export default __webpack_public_path__ + "static/media/Lato-Bold.bb154e8d.ttf";